// baseqlTypes.ts
import { DateTime } from "luxon";
import "./metaDataStore";
var Int = class {
};
Int._class = "Int";
var Float = class {
};
Float._class = "Float";
var ID = class {
};
ID._class = "ID";
var isDateTime = (type) => {
  if (typeof type?.now !== "function")
    return false;
  return DateTime.isDateTime(type.now());
};
var isGQLScalarType = (typeFunc) => {
  const type = typeFunc();
  if (isDateTime(type))
    return true;
  switch (type) {
    case String:
    case Boolean:
    case Int:
    case Float:
    case Date:
    case ID:
      return true;
    default:
      return false;
  }
};
function getTypeString(typeFunc, input = false) {
  const type = typeFunc();
  let typeString;
  typeString = type === Date ? "Date" : isDateTime(type) ? "DateTime" : type.constructor._class ? type.constructor._class : type._class ? type._class : type.name;
  return typeString + (input && !isGQLScalarType(typeFunc) ? "Input" : "");
}
export {
  Float,
  ID,
  Int,
  getTypeString,
  isDateTime,
  isGQLScalarType
};
